import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
// 👉 EDITÁ EL CONTENIDO DE ESTA SECCIÓN ABAJO
export const bonusesContent = {
  eyebrow: 'BONOS EXCLUSIVOS',
  title: 'Además, te llevás 6 bonos gratuitos',
  subtitle: 'Material extra valorado en más de $30.000 ARS, completamente sin cargo si comprás hoy.',
  bonuses: [{
    title: 'BONO 1“Planificaciones Terapéuticas Editables”',
    description: 'Modelos profesionales listos para organizar sesiones, objetivos y seguimiento terapéutico.',
    value: '$15.000'
  }, {
    title: 'BONO 2: “Actividades Imprimibles”',
    description: 'Banco de actividades listas para descargar, imprimir y aplicar en sesiones terapéuticas.',
    value: '$14.500'
  }, {
    title: 'BONO 3: “Recursos Visuales y Secuencias”',
    description: 'Material visual para anticipación, rutinas, comunicación y organización conductual..',
    value: '$9.000'
  }, {
    title: 'BONO 4: “Tarjetas Cognitivas, Emocionales y de Comunicación”',
    description: 'Tarjetas terapéuticas para trabajar emociones, lenguaje, atención y habilidades sociales.',
    value: '$7.800'
  }, {
    title: 'BONO 5: “Cuadernillo de Registro y Seguimiento”',
    description: 'Fichas clínicas y herramientas para registrar evolución, observaciones y objetivos terapéuticos.',
    value: '$7.000'
  }, {
    title: 'BONO 6: “Guía Rápida de Intervención por Áreas”',
    description: 'Estrategias prácticas y orientación profesional organizadas por áreas del neurodesarrollo.',
    value: '13.000'
  }]
};
export function Bonuses() {
  return <section className="py-24 px-4 bg-[#0f0f0f] relative overflow-hidden" data-id="element-41">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-emerald-900/10 rounded-full blur-[120px] pointer-events-none" data-id="element-42" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-43">
        <div className="text-center mb-16" data-id="element-44">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="flex justify-center mb-4" data-id="element-45">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-emerald-900/50 bg-emerald-950/30 text-emerald-200 text-sm font-medium tracking-wider uppercase" data-id="element-46">
              <Gift className="w-4 h-4" data-id="element-47" />
              {bonusesContent.eyebrow}
            </span>
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-serif mb-4 text-brand-light" data-id="element-48">
            {bonusesContent.title}
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-brand-light/70 font-sans max-w-2xl mx-auto" data-id="element-49">
            {bonusesContent.subtitle}
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-50">
          {bonusesContent.bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.08
        }} className="bg-brand-card border border-emerald-900/30 rounded-2xl p-6 hover:border-emerald-700/50 transition-colors relative" data-id="element-51">
              <div className="absolute -top-3 right-4 flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-950 border border-emerald-800 text-xs font-sans font-semibold" data-id="element-52">
                <span className="text-red-300/80 line-through" data-id="element-53">
                  {bonus.value}
                </span>
                <span className="text-emerald-200 uppercase tracking-wider" data-id="element-54">
                  Gratis
                </span>
              </div>
              <div className="w-10 h-10 rounded-lg bg-emerald-950/50 flex items-center justify-center mb-4" data-id="element-55">
                <Gift className="w-5 h-5 text-emerald-400" data-id="element-56" />
              </div>
              <h3 className="text-lg font-serif font-semibold mb-2 text-brand-light" data-id="element-57">
                {bonus.title}
              </h3>
              <p className="text-sm text-brand-light/70 font-sans leading-relaxed" data-id="element-58">
                {bonus.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}